import styled from 'styled-components';

export const SidebarFooterWrapper = styled.div<{ hasOffset?: boolean }>`
  ${({ hasOffset }) =>
    hasOffset &&
    `
    margin-bottom: 92px;
  `};
`;
